module.exports = __webpack_public_path__ + "img/clubcard-loyalty.20b5dca5.png";